// AUTO GENERATED FILE - Changes WILL be lost.
// ru - used as 'ru' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Игровой купон",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Сделать ставку",
  "betslip.clear": "Очистить все",
  "betslip.clearResult": "Очистить",
  "betslip.noSelections": "Выберите события для размещения ставки",
  "betslip.notLoggedIn": "Войдите чтобы сделать ставку",
  "betslip.refresh": "Обновить",
  "betslip.totalStake": "Сумма",
  "betslip.noHistoryData": "Нет информации по ставкам",
  "betslip.openBets": "Открытые ставки",
  "betslip.betHistory": "История ставок",
  "betslip.betHistoryWon": "Выигрыш",
  "betslip.betHistoryLost": "Проигрыш",
  "loading.loading": "Загрузка",
  "loading.account": "Загрузка аккаунта",
  "loading.league": "Загрузка лиги",
  "loading.gameweeks": "Загрузка игровой недели",
  "loading.markets": "Загрузка событий",
  "loading.bethistory": "Загрузка истории ставок",
  "login.loginRequired": "Требуется логин",
  "login.loginToBet": "Пожалуйста, войдите чтобы сделать ставку",
  "navigation.back": "Вернуться",
  "navigation.close": "Закрыть",
  "video.liveStreamAvailable": "Live трансляция доступна",
  "video.logInToWatch": "Пожалуйста, авторизуйтесь для просмотра",
  "error.error": "Ошибка",
  "error.404": "Страница не найдена",
  "error.gameLaunchFailed": "Невозможно запустить игру",
  "error.unknownErrorCode": "Неизвестная ошибка: {code}",
  "error.minUnitStakeLimitExceeded": "Минимальная ставка {limit}",
  "error.maxUnitStakeLimitExceeded": "Максимальная ставка {limit}",
  "error.minTotalStakeLimitExceeded": "Минимальная сумма ставки {limit}",
  "error.maxTotalStakeLimitExceeded": "Максимальная сумма ставки {limit}",
  "error.notPlaced": "Ставка не размещена",
  "error.wagerDisallowed": "Ставка запрещена",
  "error.errorEventIsOff": "Событие началось",
  "multiplebet.Singles": "Ординар",
  "multiplebet.Doubles": "Двойники",
  "multiplebet.Trebles": "Тройники",
  "multiplebet.Accumulator": "Экспресс",
  "multiplebet.Perm 4-Folds": "Система 4",
  "multiplebet.Perm 5-Folds": "Система 5",
  "multiplebet.Perm 6-Folds": "Система 6",
  "multiplebet.Perm 7-Folds": "Система 7",
  "multiplebet.Perm 8-Folds": "Система 8",
  "multiplebet.Perm 9-Folds": "Система 9",
  "sb-english.team.ARS": "Арсенал",
  "sb-english.team.AST": "Астон В.",
  "sb-english.team.BHA": "Брайтон",
  "sb-english.team.BOU": "Борнмут",
  "sb-english.team.BUR": "Бернли",
  "sb-english.team.CHE": "Челси",
  "sb-english.team.CRY": "К. Пэлас",
  "sb-english.team.EVE": "Эвертон",
  "sb-english.team.LEI": "Лестер",
  "sb-english.team.LIV": "Ливерпуль",
  "sb-english.team.MNC": "Манчестер С.",
  "sb-english.team.MNU": "Манчестер Ю.",
  "sb-english.team.NEW": "Ньюкасл",
  "sb-english.team.SOU": "Саутгемптон",
  "sb-english.team.TOT": "Тоттенхэм",
  "sb-english.team.WAT": "Уотфорд",
  "sb-english.team.WHU": "Вест Хэм",
  "sb-english.team.WOL": "Вульвс",
  "sb-english.team.NOR": "Норвич",
  "sb-english.team.SHU": "Шеффилд Ю.",
  "sb-english.team.LEE": "Лидс",
  "sb-english.team.FUL": "Фуллхэм",
  "sb-english.team.WBA": "Уэст Бром",
  "nomorebets": "Прием ставок закрыт",
  "playtime": "Время игры",
  "gameId": "ID игры",
  "noGames": "В данный момент отсутствуют доступные игры. Пожалуйста, попробуйте еще раз позже.",
  "Home": "Хозяева",
  "Away": "Гости",
  "Visitor": "Посетители",
  "soccerbet.gameWeek": "СЕЗОН",
  "soccerbet.noGameWeeks": "Нет доступных сезонов. Попробуйте еще раз в ближайшее время.",
  "soccerbet.league": "Таблица лиги",
  "soccerbet.table.name": "Команда",
  "soccerbet.table.won": "В",
  "soccerbet.table.drawn": "Н",
  "soccerbet.table.lost": "П",
  "soccerbet.table.points": "Очки",
  "market.abbr.Both Teams To Score": "ОЗ",
  "market.Both Teams To Score": "Обе Команды Забьют",
  "market.Over / Under": "Больше/Меньше",
  "market.Double Chance": "Двойной Результат",
  "market.Match Result": "Результат Матча",
  "market.Exact Goals": "Количество Голов",
  "market.Correct Score": "Точный Счет",
  "market.Match Result Both Score": "Результат Матча + Обе Забьют",
  "market.Result Und/Over 1.5 Total Goals": "Результат Матча + Тотал Больше/Меньше 1.5",
  "market.Result Und/Over 2.5 Total Goals": "Результат Матча + Тотал Больше/Меньше 2.5",
  "market.Under Over 1.5 Total Goals": "Тотал Больше/Меньше 1.5 голов",
  "market.Under Over 2.5 Total Goals": "Тотал Больше/Меньше 2.5 голов",
  "market.Under Over 3.5 Total Goals": "Тотал Больше/Меньше 3.5 голов",
  "market.Under Over 4.5 Total Goals": "Тотал Больше/Меньше 4.5 голов",
  "market.Total Goals 1 To 2": "Тотал от 1 до 2 голов",
  "market.Total Goals 1 To 3": "Тотал от 1 до 3 голов",
  "market.Total Goals 1 To 4": "Тотал от 1 до 4 голов",
  "market.Total Goals 2 To 3": "Тотал от 2 до 3 голов",
  "market.Total Goals 2 To 4": "Тотал от 2 до 4 голов",
  "market.Under Over 1.5 Home Goals": "Хозяева Тотал Больше/Меньше 1.5 голов",
  "market.Under Over 1.5 Away Goals": "Гости Тотал Больше/Меньше 1.5 голов",
  "market.Home Team Exact Goals": "Хозяева Количество Голов",
  "market.Away Team Exact Goals": "Гости Количество Голов",
  "selection.Yes": "Да",
  "selection.No": "Нет",
  "selection.1+G": "П1+Да",
  "selection.1+Ng": "П1+Нет",
  "selection.X+G": "Х+Да",
  "selection.X+Ng": "Х+Нет",
  "selection.2+G": "П2+Да",
  "selection.2+Ng": "П2+Нет",
  "selection.1+Yes": "1+Да",
  "selection.1+No": "1+Нет",
  "selection.X+Yes": "Х+Да",
  "selection.X+No": "Х+Нет",
  "selection.2+Yes": "2+Да",
  "selection.2+No": "2+Нет",
  "selection.TID_ANY_GOAL_SCORED_YES": "Г",
  "selection.TID_ANY_GOAL_SCORED_NO": "Нг",
  "selection.U": "М",
  "selection.O": "Б",
  "selection.1+O": "П1+Б",
  "selection.X+O": "Х+Б",
  "selection.2+O": "П2+Б",
  "selection.1+U": "П1+М",
  "selection.X+U": "Х+М",
  "selection.2+U": "П2+М",
  "selection.TID_HOME_WIN": "П1",
  "selection.TID_AWAY_WIN": "П2",
  "selection.TID_DRAW": "Х",
  "selection.TID_HOME_WIN_OR_DRAW": "П1/Х",
  "selection.TID_DRAW_OR_AWAY_WIN": "П2/Х",
  "selection.TID_HOME_OR_AWAY_WIN": "П1/П2",
  "selection.Over": "Peste",
  "selection.Under": "Sub",
  "sb-english.team.BRE": "Брентфорд",
  "sb-english.team.abbr.BRE": "БРЕ"
}
